"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _IconSortDescending = _interopRequireDefault(require("./IconSortDescending"));
var IconSortAscending = /*#__PURE__*/(0, _styledComponents.default)(_IconSortDescending.default).withConfig({
  displayName: "IconSortAscending",
  componentId: "c11n-8-107-0__sc-j24y04-0"
})(["transform:scaleY(-1);"]);
var _default = IconSortAscending;
exports.default = _default;